/**
 * ModifiedOrderItem.jsx
 * Created by Stephanie Condrey on 11/14/17.
 */

import React from 'react';
import PropTypes from 'prop-types';
import SvgLoading from '../../SvgLoading';
import * as Icons from '../../icons/Icons';
import Button from '../../Button';

const propTypes = {
    orderItemTitle: PropTypes.string,
    orderItemDetailOne: PropTypes.string,
    orderItemDetailTwo: PropTypes.string,
    orderItemPrice: PropTypes.string,
    loading: PropTypes.bool,
    showModal: PropTypes.func,
    adjustmentFeeChange: PropTypes.bool,
    disableAdjustFees: PropTypes.bool
};

export default class ModifiedOrderItem extends React.Component {
    render() {
        let modifyPrice = null;
        if (this.props.adjustmentFeeChange) {
            modifyPrice = (
                <Button
                    appearance="link"
                    size="sm"
                    onClick={() => this.props.showModal()}
                    isDisabled={this.props.disableAdjustFees || this.props.loading}
                    iconBeforeElement={<Icons.IconEdit />}>
                    Adjust Fees
                </Button>
            );
        }
        return (
            <div className="rec-order-item-row">
                <div className="rec-order-item-col">
                    <div className="h4">{this.props.orderItemTitle}</div>
                    <p>{this.props.orderItemDetailOne}</p>
                    <p>{this.props.orderItemDetailTwo}</p>
                </div>
                <div className="rec-order-item-col">
                    {this.props.loading ? <SvgLoading size="small" /> : <p className="item-price">{this.props.orderItemPrice}</p>}
                    {modifyPrice}
                </div>
            </div>
        );
    }
}
ModifiedOrderItem.propTypes = propTypes;
